/* eslint-disable max-len */
import angular from 'angular';
import constants from 'app/constants';
import {
  amDataService,
  loaderService,
  ssDialogService
} from 'app/services';
import {
  alerts
} from 'app/components/global';
import controller from './add-agendaItem-note-dialog.controller';
import template from './add-agendaItem-note-dialog.html';
// import validator, { name as validatorName } from '../messages/finding-unique-name.validator.directive';
import nameTpl from '../messages/agenda.item.name.messages.html';


class dialogService {
  getOptions($event, {
    agendaItemId, agendaItemCommentId, agendaItemCommentText, agendaItemFollowupId, agendaItemFollowupText, refreshAgendaItem
  }) {
    return {
      controller,
      controllerAs: 'addAgendaItemNoteDialogVM',
      locals: {
        agendaItemId,
        agendaItemCommentId,
        agendaItemCommentText,
        agendaItemFollowupId,
        agendaItemFollowupText,
        refreshAgendaItem
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.oversight.addAgendaItemNoteDialog', [
  alerts,
  amDataService,
  constants,
  loaderService,
  ssDialogService,
])
// .directive(validatorName, validator)
  .service('addAgendaItemNoteDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('agenda.item.name.messages.html', nameTpl);
  })
  .name;
